import React, { Component } from "react";
import Dropdown from "../../../pageBreakup/Dropdown/index";
import IsdCodeDropdown from "../../../pageBreakup/IsdDropDown/index";
import getCountriesList from "../../../../lib/getCountriesList";
import { withRouter } from "next/router";
import {
  emailValidation,
  nameValidation,
  noLeadingSpace,
  onlyNumbersRegex,
  mobile_number,
  alphabetsAndSpaceswithLength
} from "../../../../lib/utils/regex_cheat_sheet";
import { updateProfile } from '../../../../lib/myProfile'
import { register } from "../../../../lib/register";
import commonFunction from "../../../../lib/utils/common.js";
import Theme12 from "..";
class ProfileComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      originCountries: [],
      //   verification: false,
      registerSuccess: false,
      //   isMobile: this.props.data.isMobile,
      registration_token: "",
      isLoading: false,
      accept_terms: false,
      title: "",
      mobileTime: 180000,
      emailTime: 180000,
      site_id: this.props?.data?.siteData?.data.site_id,
      travellerRegistration: {
        first_name: "",
        last_name: "",
        email: "",
        mobile_number: "",
        country_code: {
          _id: "659bae6115a45d1c587e99b0",
          contry_name: "India",
          contry_code: "IN",
          contry_loc_code: "IND",
          contry_flag: "/shared/api/media/flag/IN.svg",
          contry_isd: "91",
          contry_status: "Active",
          __v: 0,
          createdAt: "2024-01-08T08:12:17.766Z",
          updatedAt: "2024-09-03T11:26:13.029Z",
        },
      },
      travellerRegistrationErrors: {
        first_name: "",
        last_name: "",
        email: "",
        mobile_number: "",
        title: "",
        terms_accept: "",
        country_code: "",
      },
    };
    this.mobileInterval = null;
    this.emailInterval = null;
  }

  componentDidMount() {
    if (this.state.mobileTime > 0) {
      this.mobileInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.mobileTime <= 1000) {
            clearInterval(this.mobileInterval);
            return { mobileTime: 0 };
          }
          return { mobileTime: prevState.mobileTime - 1000 };
        });
      }, 1000);
    }

    if (this.props.email) {
      this.setState(prev => ({
        travellerRegistration: {
          ...prev.travellerRegistration,
          email: this.props.email
        }
      }));
    }


    if (this.state.emailTime > 0) {
      this.emailInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.emailTime <= 1000) {
            clearInterval(this.emailInterval);
            return { emailTime: 0 };
          }
          return { emailTime: prevState.emailTime - 1000 };
        });
      }, 1000);
    }

    getCountriesList().then((resp) => {
      let countryList = [];
      if (resp?.data?.length > 0) {
        resp?.data.map((item) => {
          countryList.push({
            ...item,
            id: item.contry_code,
            label: item.contry_name,
            value: item.contry_name,
            isdCode: item.contry_isd,
            countryCode: item.contry_code,
            flag: item.contry_flag,
            countryFlag: item.contry_flag,
            countryName: item.contry_name,
          });
        });
      }
      this.setState({ originCountries: countryList });
    });
  }

  componentWillUnmount() {
    clearInterval(this.mobileInterval);
    clearInterval(this.emailInterval);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.mobileTime !== this.state.mobileTime &&
      this.state.mobileTime > 0
    ) {
      clearInterval(this.mobileInterval);
      this.mobileInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.mobileTime <= 1000) {
            clearInterval(this.mobileInterval);
            return { mobileTime: 0 };
          }
          return { mobileTime: prevState.mobileTime - 1000 };
        });
      }, 1000);
    }

    if (
      prevState.emailTime !== this.state.emailTime &&
      this.state.emailTime > 0
    ) {
      clearInterval(this.emailInterval);
      this.emailInterval = setInterval(() => {
        this.setState((prevState) => {
          if (prevState.emailTime <= 1000) {
            clearInterval(this.emailInterval);
            return { emailTime: 0 };
          }
          return { emailTime: prevState.emailTime - 1000 };
        });
      }, 1000);
    }

    if (!prevState.registerSuccess && this.state.registerSuccess) {
      setTimeout(() => {
        this.props.router.push("/");
      }, 2000);
    }
  }

  handleChange = (key, val) => {
    // Regex to allow only letters and spaces
    const nameRegex = /^[a-zA-Z\s]*$/;

    // For name fields, block invalid characters during typing
    if (key === 'first_name' || key === 'last_name') {
      // Don't allow leading space
      if (val.length > 0 && val[0] === ' ') {
        return;
      }
      // Only allow letters (a-z, A-Z) and spaces - block everything else
      if (val !== '' && !nameRegex.test(val)) {
        return;
      }
      // Limit to 50 characters
      if (val.length > 50) {
        return;
      }
    }

    // For mobile number, only allow numbers
    if (key === 'mobile_number') {
      if (val !== '' && !onlyNumbersRegex.test(val)) {
        return;
      }
      // Limit to 15 digits
      if (val.length > 15) {
        return;
      }
    }

    // For email, allow typing (validation happens on submit)
    if (key === 'email' && val !== '' && !noLeadingSpace.test(val)) {
      return;
    }

    this.setState((prevState) => ({
      travellerRegistration: {
        ...prevState.travellerRegistration,
        [key]: val,
      },
    }));
    this.setState((prevState) => ({
      travellerRegistrationErrors: {
        ...prevState.travellerRegistrationErrors,
        [key]: "",
      },
    }));
  };

  handleSubmit = (event) => {
    this.setState({ isLoading: true })
    event.preventDefault();
    const { travellerRegistration } = this.state;
    const errors = {};

    // console.log("traveller", travellerRegistration);

    if (!travellerRegistration.title) {
      errors.title = "Select Title";
    }

    const trimmedFirstName = travellerRegistration.first_name?.trim() || '';
    if (!trimmedFirstName) {
      errors.first_name = "Please enter first name";
    } else if (!alphabetsAndSpaceswithLength.test(trimmedFirstName)) {
      errors.first_name = "First name must be 2-50 characters";
    }

    const trimmedLastName = travellerRegistration.last_name?.trim() || '';
    if (!trimmedLastName) {
      errors.last_name = "Please enter last name";
    } else if (!alphabetsAndSpaceswithLength.test(trimmedLastName)) {
      errors.last_name = "Last name must be 2-50 characters";
    }

    if (!travellerRegistration.email) {
      errors.email = "Please enter email id";
    } else if (!emailValidation.test(travellerRegistration.email)) {
      errors.email = "Please enter valid email id.";
    }
    if (!travellerRegistration.mobile_number) {
      errors.mobile_number = "Please enter mobile number";
    } else if (!mobile_number.test(travellerRegistration.mobile_number)) {
      errors.mobile_number = "Please enter a valid mobile number (8-15 digits)";
    }
    const isd = travellerRegistration?.country_code?.contry_isd;
    if (!isd || !/^\d{1,3}$/.test(String(isd))) {
      errors.country_code = "Select ISD code";
    }
    // if (!travellerRegistration.country) {
    //   errors.country = "Please select country";
    // }
    if (!travellerRegistration.accept_terms) {
      errors.accept_terms = "You must accept the terms and conditions.";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({
        travellerRegistrationErrors: {
          ...errors,
        },
        isLoading: false
      });
      return;
    }

    const { accept_terms, ...rest } = travellerRegistration;



    const payload = {
      ...rest,
      first_name: travellerRegistration.first_name?.trim(),
      last_name: travellerRegistration.last_name?.trim(),
      country_code: {
        value: this.state.travellerRegistration?.country_code?.contry_name,
        countryFlag:
          this.state.travellerRegistration?.country_code?.contry_flag,
        countryName:
          this.state.travellerRegistration?.country_code?.contry_name,
        isdCode: this.state.travellerRegistration?.country_code?.contry_isd,
        countryCode:
          this.state.travellerRegistration?.country_code?.contry_code,
        flag: this.state.travellerRegistration?.country_code?.contry_flag,
      },
      site_id: this.state.site_id,
      registraion_token: this.props?.registration_token || commonFunction.getCookie("registration_token"),
      isNormalLogin: false,
      nationality: {
        code: this.state.travellerRegistration?.country_code?.contry_code,
        name: this.state.travellerRegistration?.country_code?.contry_name
      },
      country_code: {
        isdCode: "+" + this.state.travellerRegistration?.country_code?.contry_isd,
        countryCode: this.state.travellerRegistration?.country_code?.contry_code
      },
    };

    register(payload).then((response) => {
      if (response.status) {
        this.setState({ registerSuccess: true, isLoading: false }, () => {
          window.location.reload();
        });
      }
    });


    //  travellerSignup(payload).then((response) => {
    //       if (response?.data?.registration_token) {
    //         this.setState({
    //           travellerRegistrationErrors: {
    //             firstName: "",
    //             lastName: "",
    //             email: "",
    //             mobile: "",
    //             title: "",
    //             termsAccepted: "",
    //           },
    //           verification: true,
    //           registration_token: response?.data?.registration_token,
    //           mobileTime: response?.data?.mobile_otp?.otp_expiry_time,
    //           emailTime: response?.data?.email_otp?.otp_expiry_time,
    //           isLoading: false,
    //         });
    //       }
    //     });handleSubmit

  };

  // renderSuccess() {
  //   return (
  //     // <div className={this.props.styles.redirect__container}>
  //     //   <p>Redirecting to homepage...</p>
  //     //   <h2>Welcome {this.state.travellerRegistration.first_name}</h2>
  //     // </div>
  //     window.location.reload()
  //   );
  // }

  // handleBack = () => {
  //   // if (this.state.verification) {
  //   //   this.setState({ verification: false });
  //   // } else {
  //   //   this.props.data.onClickCross();
  //   // }
  //   // console.log("Back Button");
  // };

  renderForm() {
    const { styles, email } = this.props;
    // console.log("bbbb", styles);
    return (
      <div className={styles.email_otp}>
        <div className={styles.email_otp__background}>
          <div className={styles.email_otp__content}>
            <div className={styles.email_otp__form_header}>
              <div className={`${styles.email_otp__icon} ${styles.profile__icon}`}>
                <img src="/images/user-account.svg" alt="user" />
              </div>
              <h2 className={styles.email_otp__form_title}>
                {" "}
                Let's Complete Your Profile
              </h2>
              <p className={styles.email_otp__form_description}>
                This helps us personalize your experience
              </p>
            </div>

            <div
              className={`${styles.email_otp__form_container} custom_scrollbar`}
            >
              <form className={styles.email_otp__form}>
                {/* Row 1 : First Name And Last Name */}
                <div className={styles.profile__row}>
                  <div className={styles.email_otp__field}>
                    <label
                      htmlFor="firstName"
                      className={styles.email_otp__label}
                    >
                      First Name <span className={styles.required}>*</span>
                    </label>
                    <div className={styles.email_otp__form__input}>
                      <div className={styles.profile__dropdown_wrapper}>
                        <Dropdown
                          theme={"theme12"}
                          options={["Mr", "Mrs", "Miss"]}
                          placeholder="Title"
                          showCrossIcon={true}
                          label=""
                          showLabel={true}
                          onChange={(selectedOption) =>
                            this.handleChange("title", selectedOption)
                          }
                          showSearch={false}
                          value={this.state.travellerRegistration.title}
                          error={this.state.travellerRegistrationErrors.title}
                          styles={this.props.dropdownStylesTheme12}
                        />
                      </div>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        className={styles.profile__form__input}
                        placeholder="Enter your first name"
                        onChange={(e) =>
                          this.handleChange("first_name", e.target.value)
                        }
                        value={this.state.travellerRegistration.first_name}
                        maxLength={50}
                      />
                    </div>
                    <div className={styles.profile__error}>
                      {this.state.travellerRegistrationErrors.title && (
                        <div
                          className={`${styles.error} ${styles.error_title}`}
                        >
                          {this.state.travellerRegistrationErrors.title}
                        </div>
                      )}
                      {this.state.travellerRegistrationErrors.first_name && (
                        <div
                          className={`${styles.error} ${styles.error_firstname}`}
                        >
                          {this.state.travellerRegistrationErrors.first_name}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className={styles.email_otp__field}>
                    <label
                      htmlFor="lastName"
                      className={styles.email_otp__label}
                    >
                      Last Name <span className={styles.required}>*</span>
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      className={styles.email_otp__input}
                      placeholder="Enter your last name"
                      onChange={(e) =>
                        this.handleChange("last_name", e.target.value)
                      }
                      value={this.state.travellerRegistration.last_name}
                      maxLength={50}
                    />
                    {this.state.travellerRegistrationErrors.last_name && (
                      <div className={styles.profile__error}>
                        <div className={styles.error}>
                          {this.state.travellerRegistrationErrors.last_name}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className={styles.email_otp__field}>
                    <label htmlFor="email" className={styles.email_otp__label}>
                      Email <span className={styles.required}>*</span>
                    </label>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      className={`${styles.email_otp__input} ${styles.form__email}`}
                      placeholder="Enter your email id"
                      // onChange={(e) =>
                      //   this.handleChange("email", e.target.value)
                      // }
                      disabled={true}
                      // value={email}
                      value={this.state.travellerRegistration.email}
                    />
                    {/* requirement as per figma go to email change page */}
                    <div className={styles.change_mail} onClick={() => this.props.handleChangeStep("changeEmail")}>
                      <div className={styles.change_mail_imgbox}>
                        <img src="/images/mail.svg" alt="mail" className={styles.change_mail_img} />
                      </div>
                      <p className={styles.change_mail_text}>Click here to change email id </p>
                    </div>
                    {this.state.travellerRegistrationErrors.email && (
                      <div className={styles.profile__error}>
                        <div className={styles.error}>
                          {this.state.travellerRegistrationErrors.email}
                        </div>
                      </div>
                    )}
                  </div>



                  <div className={styles.email_otp__field}>
                    <label htmlFor="mobile" className={styles.email_otp__label}>
                      Mobile <span className={styles.required}>*</span>
                    </label>
                    <div className={styles.email_otp__input_group}>
                      <div className={styles.profile__dropdown_wrapper}>
                        <div className={styles.country_code}>
                          <IsdCodeDropdown
                            theme={"theme12"}
                            onSelect={(selectedOption) =>
                              this.handleChange("country_code", selectedOption)
                            }
                            value={"+91"}
                            styles={this.props.IsdCodeDropdownCss}
                          />
                        </div>
                      </div>
                      <div className={styles.mobile_input_wrapper}>
                        <input
                          type="tel"
                          id="mobile"
                          name="mobile"
                          minLength={8}
                          maxLength={15}
                          className={styles.email_otp__input}
                          placeholder="Mobile number"
                          onChange={(e) =>
                            this.handleChange("mobile_number", e.target.value)
                          }
                          value={this.state.travellerRegistration.mobile_number}
                        />
                      </div>
                    </div>
                    <div className={styles.error_container}>
                      {this.state.travellerRegistrationErrors.country_code && (
                        <div className={styles.profile__error}>
                          <div className={styles.error}>
                            {this.state.travellerRegistrationErrors.country_code}
                          </div>
                        </div>
                      )}
                      {this.state.travellerRegistrationErrors.mobile_number && (
                        <div className={styles.profile__error}>
                          <div className={styles.error}>
                            {this.state.travellerRegistrationErrors.mobile_number}
                          </div>
                        </div>
                      )}
                    </div>

                  </div>
                </div>



                {/* Terms */}
                <div className={styles.profile__terms}>
                  <div className={styles.profile__terms_wrapper}>
                    <label
                      htmlFor="terms"
                      className={styles.profile__checkbox_container}
                    >
                      <input
                        type="checkbox"
                        className={styles.profile__checkbox_input}
                        id="terms"
                        name="terms"
                        checked={this.state.travellerRegistration.accept_terms}
                        onChange={() =>
                          this.handleChange(
                            "accept_terms",
                            !this.state.travellerRegistration.accept_terms
                          )
                        }
                      />
                      <div className={styles.profile__terms_text}>
                        I agree to the{" "}
                        <a href="/terms-and-conditions" className={styles.profile__terms_link} onClick={(e) => e.stopPropagation()} target="_blank">
                          Terms and Conditions
                        </a>{" "}
                        and{" "}
                        <a href="/privacy-policy" className={styles.profile__terms_link} onClick={(e) => e.stopPropagation()} target="_blank">
                          Privacy Policy
                        </a>
                      </div>
                    </label>
                  </div>
                  {this.state.travellerRegistrationErrors.accept_terms && (
                    <div className={`${styles.profile__error} ${styles.error}`}>
                      {this.state.travellerRegistrationErrors.accept_terms}
                    </div>
                  )}
                </div>

                {/* Submit */}
                <div className={styles.email_otp__submit_container}>
                  <button
                    type="submit"
                    className={`${styles.email_otp__submit_btn} 
                     ${this.state.isLoading ? "loading" : ""}`}
                    onClick={this.handleSubmit}
                  // disabled={!payload}
                  >
                    <span>Continue</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    // return this.state.registerSuccess
    //   ? this.renderSuccess()
    //   : this.renderForm();

    return this.renderForm();
  }
}

export default withRouter(ProfileComponent);
